
import IconAction from '@/components/IconAction/IconAction.vue'
import ViewModel from '@/models/ViewModel'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    IconAction,
  },
})
export default class ManageActionsBtns extends ViewModel {
  @Prop({ default: false }) public disabled!: boolean
}
